/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Thunderstorm_HailInputs */

const en_ui_weather_thunderstorm_hail = /** @type {(inputs: Ui_Weather_Thunderstorm_HailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thunderstorm with hail`)
};

const de_ui_weather_thunderstorm_hail = /** @type {(inputs: Ui_Weather_Thunderstorm_HailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewitter mit Hagel`)
};

/**
* | output |
* | --- |
* | "Thunderstorm with hail" |
*
* @param {Ui_Weather_Thunderstorm_HailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_thunderstorm_hail = /** @type {((inputs?: Ui_Weather_Thunderstorm_HailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Thunderstorm_HailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_thunderstorm_hail(inputs)
	return de_ui_weather_thunderstorm_hail(inputs)
});